/** Emitted after participate/unroll so `WidgetNewContest` can refresh without a shared React parent. */
export const KT_COURSE_PARTICIPATION_CHANGED = "kt-course-participation-changed";
